import React, { useEffect } from 'react';
import { FiTrash2, FiX } from 'react-icons/fi';
import Styles from './BulkActionToolbar.module.scss';

const BulkActionToolbar = ({
  selectedCount = 0,
  onBulkDelete,
  isLoading = false,
  onClearSelection,
  itemType = 'items',
  showKeyboardShortcuts = true,
}) => {
  if (!selectedCount || selectedCount === 0) {
    return null;
  }

  // Keyboard shortcut handler
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Delete key for bulk delete
      if (event.key === 'Delete' && !isLoading && selectedCount > 0) {
        event.preventDefault();
        onBulkDelete();
      }
      // Escape key to clear selection
      if (event.key === 'Escape' && !isLoading) {
        event.preventDefault();
        onClearSelection();
      }
    };

    if (showKeyboardShortcuts) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [
    onBulkDelete,
    onClearSelection,
    isLoading,
    selectedCount,
    showKeyboardShortcuts,
  ]);
  const getCountText = () => {
    const itemText = selectedCount === 1 ? itemType.slice(0, -1) : itemType;
    return `${selectedCount} ${itemText} selected`;
  };

  return (
    <div
      className={Styles.BulkActionToolbar}
      role="toolbar"
      aria-label="Bulk actions toolbar"
    >
      <div className={Styles.BulkActionToolbar__Content}>
        <div className={Styles.BulkActionToolbar__Info}>
          <span
            className={Styles.BulkActionToolbar__Count}
            aria-live="polite"
            aria-atomic="true"
          >
            {getCountText()}
          </span>
          <button
            className={Styles.BulkActionToolbar__ClearButton}
            onClick={onClearSelection}
            disabled={isLoading}
            aria-label="Clear selection (Escape)"
            title="Clear selection (Escape)"
          >
            <FiX size={13} />
            Clear selection
          </button>
        </div>
        <div className={Styles.BulkActionToolbar__Actions}>
          <button
            className={Styles.BulkActionToolbar__DeleteButton}
            onClick={onBulkDelete}
            disabled={isLoading}
            aria-label="Delete selected briefs"
            title="Delete selected briefs"
          >
            {isLoading ? (
              <span className="spinner-border spinner-border-sm" />
            ) : (
              <FiTrash2 size={16} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionToolbar;
